import { css, type Theme } from "@emotion/react";
import { borders } from "aviary-tokens";

import { utilities } from "@styles";

export const toolbarBtn = {
  base: (theme: Theme) => css`
    cursor: pointer;
    ${utilities.transition}
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: ${borders.radiusBase};
    box-sizing: border-box;
    height: 2rem;
    width: 2rem;
    gap: 0.25rem;
    color: ${theme.system.textLabelEmphasis};

    &:active {
      color: ${theme.system.textLabelEmphasis};
    }

    &:hover {
      background-color: ${theme.system.backgroundMutedActive};
    }
  `,

  active: (theme: Theme) => css`
    background-color: ${theme.system.backgroundMutedActive};
    color: ${theme.system.textLabelEmphasis};
  `,
};
